import API from "./API";

export default class Suppliers extends API
{
    static async search(filter) {
        return this.get("api/admin/fornecedores",{params: filter});
    }
    
    static async find(id) {
        return this.get("api/admin/fornecedores/" + id);
    }

    static async list(){
        return this.get("api/admin/fornecedores/all");
    }
}